import { useState, useEffect, useRef } from 'react';
import cn from 'classnames';
import { ReactComponent as ChevronIcon } from './assets/chevron.svg';
import { useClickOutside } from '../../utils/useClickOutside';

import styles from './Filter.module.scss';

export interface DropdownFilterProps {
  title: string;
  counter: number;
  isExclude?: boolean;
  children: React.ReactNode;
  onOpenChange?: (isOpen: boolean) => void;
}

export const DropdownFilter: React.FC<DropdownFilterProps> = ({
  title,
  counter,
  isExclude = false,
  children,
  onOpenChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const clickRef = useRef(null);

  const handleToggle = (newIsOpen: boolean) => {
    setIsOpen(newIsOpen);
    onOpenChange?.(newIsOpen);
  };

  useClickOutside(clickRef, () => {
    if (isOpen) {
      handleToggle(false);
    }
  });

  return (
    <div className={styles.dropdownFilterWrapper} ref={clickRef}>
      <button
        className={cn(styles.filterButton, { [styles.active]: isOpen })}
        onClick={() => handleToggle(!isOpen)}
      >
        <span>{title}</span>
        {counter > 0 ? <span className={cn(styles.filterCounter, isExclude ? styles.countExclude : '')}>
          {counter}
        </span> : null}
        <span className={styles.chevron}>
          <ChevronIcon />
        </span>
      </button>
      <div className={cn(styles.dropdownFilterContainer, isOpen ? styles.show : '')}>
        {children}
      </div>
    </div>
  );
};
